<div id="gantEditorTemplates" style="display:none;">
    <div *ngFor="let key of keys" class="__template__" [attr.type]="key">
        <comment [contents]="templates[key]"></comment>
    </div>
</div>